// GA4 tracking for the community post page /:slug/community/:id.
//
// The trial CTA is a server-rendered link, and community posts are the main
// entry for new visitors, so its clicks are counted here. Signed-in readers
// go to the team's courses section; signed-out readers go to signup first.
//
// ⛔ Never pass the post title or body.
import { trackEvent } from 'utils/analytics'

// @param {HTMLElement|null} link the #community-trial-cta anchor
// @param {Object} context
// @param {string} context.teamSlug
// @param {number} context.postId
// @param {boolean} context.signedIn
export function trackCommunityTrialCta(link, { teamSlug, postId, signedIn }) {
  if (!link) return

  // No preventDefault: the beacon survives the navigation, so the link is
  // never delayed.
  link.addEventListener('click', () => {
    try {
      trackEvent('community_trial_cta_click', {
        team_slug: teamSlug,
        post_id: postId,
        signed_in: signedIn,
        transport_type: 'beacon'
      })
    } catch (error) {
      // Analytics must never break the link.
      console.error('[Analytics] community_trial_cta_click failed:', error)
    }
  })
}
